import { Skeleton } from "@/components/ui/skeleton";

/** Loading placeholder mirroring FamilyAcquisitionCard (separator + card). */
export function FamilyAcquisitionCardSkeleton() {
  return (
    <div className="my-8 text-left">
      <div className="relative px-4">
        <div className="absolute inset-0 flex items-center" aria-hidden="true">
          <div className="w-full border-t border-gray-300" />
        </div>
        <div className="relative flex items-center justify-start">
          <span className="inline-flex items-center bg-slate-50 px-3">
            <Skeleton className="h-12 w-12 rounded-full" />
            <Skeleton className="ml-4 h-5 w-44" />
          </span>
        </div>
      </div>

      <div className="mt-6">
        <div className="flex justify-end">
          <Skeleton className="h-4 w-48" />
        </div>
        <div className="mt-2 rounded-lg border bg-white p-6">
          <Skeleton className="h-7 w-44 rounded-md" />
          <div className="mt-4 space-y-4 py-6">
            {["w-72", "w-64", "w-56"].map((width) => (
              <div key={width} className="flex items-center gap-2">
                <Skeleton className="h-5 w-5 rounded" />
                <Skeleton className={`h-4 ${width}`} />
              </div>
            ))}
          </div>
          <div className="mt-4 border-t pt-4">
            <Skeleton className="h-4 w-40" />
            <Skeleton className="mt-3 h-20 w-full rounded-md" />
          </div>
        </div>
      </div>
    </div>
  );
}
